document.addEventListener("DOMContentLoaded", () => {
  const checkInterval = setInterval(() => {
    const sizeSelect = document.querySelector('select#Size');
    if (sizeSelect) {
      const optionSixPack = Array.from(sizeSelect.options).find(
        opt => opt.value.trim() === "6 Pack"
      );

      if (optionSixPack) {
        sizeSelect.removeChild(optionSixPack);
        sizeSelect.insertBefore(optionSixPack, sizeSelect.firstChild);
        // ✅ Đặt "6 Pack" làm giá trị được chọn
        sizeSelect.value = "6 Pack";
        console.log("✅ '6 Pack' moved to top and selected");

        clearInterval(checkInterval);
      }
    }
  }, 300);
  setTimeout(() => clearInterval(checkInterval), 5000);
});
